module.exports = __webpack_public_path__ + "media/images/cta-9066cb198ed931a1bf8130d430110817.svg";